import { Callout, HTMLTable, Spinner } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import i18n from "../../../../i18n";
import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";
import PieChart from "../../../Charts/PieChart";

export default function Detections(props) {
  const [detections, setDetections] = useState();

  useEffect(() => {
    authenticatedGetFetch(
      "/ow/dc/perf/detectionpertransaction?" +
        new URLSearchParams({
          srv: props.srv,
          ...(props.from && { from: props.from }),
          ...(props.to && { to: props.to }),
        }),
      (detections) => setDetections(detections)
    );
  }, [props.srv, props.from, props.to]);

  return (
    <Callout icon="mobile-video" title={<Trans>detections</Trans>}>
      {detections ? (
        <div className="flexbox-left">
          <div>
            <HTMLTable compact={true} striped={true}>
              <thead>
                <tr>
                  <th>
                    <Trans>detection nb</Trans>
                  </th>
                  <th>
                    <Trans>number of transaction</Trans>
                  </th>
                </tr>
              </thead>
              <tbody>
                {detections.map((l) => (
                  <tr key={"dc" + l.detection_count}>
                    <td>{l.detection_count}</td>
                    <td>{l.count}</td>
                  </tr>
                ))}
              </tbody>
            </HTMLTable>
          </div>
          <div>
            <PieChart
              labels={detections.map((c) => c.detection_count)}
              data={detections.map((c) => c.count)}
              title={i18n.t("detections")}
            />
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </Callout>
  );
}
